// extracted by mini-css-extract-plugin
export default {"loginForm__form":"LoginForm_loginForm__form__TdrWX","loginForm__button":"LoginForm_loginForm__button__y9ZXd"};